export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/11a14d9b63ec892bb84cea8c67204259.svg";